import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import useFormValidator from 'useFormValidator';
import Modal from 'modules/common/components/Modal';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Address from 'modules/common/address/Address';
import * as actions from '../action';
import * as c from '../constant';

function OwnerModal({
  createLandOwner,
  getLandOwnerList,
  history,
  getSingleLandOwner,
  creating,
  updateList,
  updateLandOwner,
  id,
  type,
}) {
  const setModal = useContext(ModalContext);

  const [formData, setFormData] = useState({
    name: '',
    telephone_no: '',
    tin: '',
    region_code: '',
    province_code: '',
    municipality_code: '',
    barangay_code: '',
    street: '',
  });

  const validateForm = useFormValidator(formData, {
    name: 'required',
    telephone_no: 'required|tel_number',
    tin: 'required',
    region_code: 'required',
    province_code: 'required',
    municipality_code: 'required',
    barangay_code: 'required',
    street: 'required',
  });

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeAddress = e => {
    setFormData({
      ...formData,
      region_code: e.target.value.region_code,
      province_code: e.target.value.province_code,
      municipality_code: e.target.value.municipality_code,
      barangay_code: e.target.value.barangay_code,
      street: e.target.value.street || '',
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      name: _.get(formData, 'name').replace(/\s+/g, ' ').trim(),
    };
    if (type === 'NEW') {
      createLandOwner(args, ({ data }) => {
        setModal({ isOpen: false });
        getLandOwnerList();
        history.push(
          `/rpt/land/land-owner/${_.get(data, 'id')}`
        );
        getSingleLandOwner(data.id);
      });
    }
    if (type === 'EDIT') {
      updateLandOwner(id, args, ({ data }) => {
        setModal({ isOpen: false });
        getLandOwnerList();
        history.push(
          `/rpt/land/land-owner/${_.get(data, 'id')}`
        );
        getSingleLandOwner(data.id);
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Land Owner: {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <h3 className="col-12 cms-text-primary font-weight-bold left-address">Address</h3>
            <Address
              required
              value={{
                region_code: _.get(formData, 'region_code') || '',
                province_code:
                  _.get(formData, 'province_code') || '',
                municipality_code:
                  _.get(formData, 'municipality_code') || '',
                barangay_code:
                  _.get(formData, 'barangay_code') || '',
                street: _.get(formData, 'street') || '',
              }}
              onChange={onChangeAddress}
              type="Address"
              region_name="region_code"
              province_name="province_code"
              municipality_name="municipality_code"
              barangay_name="barangay_code"
              street_name="street"
              name="address"
              validatorMessage={validateForm.renderMessage}
              removeLabel
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Telephone No.{' '}
              {validateForm.renderMessage('telephone_no')}
            </label>
            <InputMask
              className="form-control"
              mask="99-9999-9999"
              alwaysShowMask={false}
              type="text"
              name="telephone_no"
              onChange={onChange}
              value={_.get(formData, 'telephone_no') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              TIN
              {validateForm.renderMessage('tin')}
            </label>
            <InputMask
              className="form-control"
              mask="999-999-999-999"
              alwaysShowMask={false}
              type="text"
              name="tin"
              onChange={onChange}
              value={_.get(formData, 'tin') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

OwnerModal.defaultProps = {
  updateList: {},
  id: '',
};

OwnerModal.propTypes = {
  getLandOwnerList: PropTypes.instanceOf(Function).isRequired,
  createLandOwner: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleLandOwner: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  updateList: PropTypes.instanceOf(Object),
  updateLandOwner: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string,
  type: PropTypes.string.isRequired
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_LAND_OWNER) > -1,
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(OwnerModal);
